var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIconBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 69,
    viewBox: "0 0 70 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24590_220128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5234 31.625C32.8747 31.625 38.0234 26.4763 38.0234 20.125C38.0234 13.7737 32.8747 8.625 26.5234 8.625C20.1722 8.625 15.0234 13.7737 15.0234 20.125C15.0234 26.4763 20.1722 31.625 26.5234 31.625Z",
    stroke: "#FAFEFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.27344 60.375V54.625C9.27344 51.575 10.485 48.6499 12.6417 46.4933C14.7984 44.3366 17.7234 43.125 20.7734 43.125H32.2734C35.3234 43.125 38.2485 44.3366 40.4052 46.4933C42.5618 48.6499 43.7734 51.575 43.7734 54.625V60.375",
    stroke: "#FAFEFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6484 9C49.1221 9.63337 51.3147 11.072 52.8804 13.0891C54.4461 15.1063 55.296 17.5871 55.296 20.1406C55.296 22.6941 54.4461 25.175 52.8804 27.1921C51.3147 29.2092 49.1221 30.6479 46.6484 31.2813",
    stroke: "#FAFEFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0234 60.3812V54.6313C61.0088 52.0931 60.1549 49.631 58.5948 47.6289C57.0347 45.6268 54.8561 44.197 52.3984 43.5625",
    stroke: "#FAFEFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24590_220128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 69,
    fill: "white",
    transform: "translate(0.648438)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconBig);
export default __webpack_public_path__ + "static/media/user-icon-big.86d504f06825fa3f0dff9b03af146a4d.svg";
export { ForwardRef as ReactComponent };